<div class="mt-5">
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
</div>

<div class="row justify-content-center bg-color py-5">
  <div class="col-11">
    <div class="row">
      <div class="col-md-6 pr-lg-0">
        <div class="bg-white d-flex align-items-center">
          <div class="formDiv m-auto">
            <h3 class="text-center mb-5">CHANGE PASSWORD</h3>
             <form class="viewProfileForm" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit(changePasswordForm.value); changePasswordForm.reset()">
               
                <div class="form-group">
                  <input type="password" class="form-control" placeholder="Enter New Password"  id="password" required name="password" formControlName="password" (focus)="onFocusFunction()">
                   <div *ngIf="changePasswordForm.controls['password'].errors && !changePasswordForm.controls['password'].pristine" class="text-danger">
                      <div [hidden]="!changePasswordForm.controls['password'].errors.required">Password is required.</div>
                      <div [hidden]="!changePasswordForm.controls['password'].errors.minlength">Password must be at least 8 characters long.</div>
                    </div>
                </div> 
                <div class="form-group">   
                  <input type="password" class="form-control" placeholder="Retype New Password"  id="password_confirmation" required name="password_confirmation" formControlName="password_confirmation"  (focus)="onFocusFunction()" (keyup)="matchpasswords($event.target.value)">
                  <div *ngIf="changePasswordForm.controls['password_confirmation'].errors && !changePasswordForm.controls['password_confirmation'].pristine" class="text-danger">
                      <div [hidden]="!changePasswordForm.controls['password_confirmation'].errors.required">Confirm Password is required.</div>
                    </div>
                  <p *ngIf="passwordmatchFlag" class="text-danger">  Password doesn't match!</p>
                 
                </div>
                 <button class="form-control callSubmit mt-2" type="submit"  [disabled]="!changePasswordForm.valid">Change Password!</button>
             </form>
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-lg-0">
        <img src="../../../../assets/img/customer/password.jpg" class="img-fluid">
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/customer/cus-change-password/cus-change-password.component.html